import { RouteRecordRaw } from '@bv/router';

import { sallaBreadcrumbs } from '@/router/main/breadcrumbs';

export const sallaRoutes: RouteRecordRaw = {
  path: 'salla',
  component: () => import('@/views/Main/integrations/salla/SallaWrapper.vue'),
  children: [
    {
      path: '',
      name: 'int-salla-integration',
      meta: {
        title: 'integrations.salla.integration_title_trans',
        breadcrumbs: sallaBreadcrumbs(),
      },
      component: () => import('@/views/Main/integrations/salla/SallaIntegration.vue'),
    },
    {
      path: 'events',
      name: 'int-salla-events',
      meta: {
        title: 'integrations.salla.events_title_trans',
        breadcrumbs: sallaBreadcrumbs({
          label: 'integrations.salla.events_title_trans',
          route: { name: 'int-salla-events' },
        }),
      },
      component: () => import('@/views/Main/integrations/salla/SallaEvents.vue'),
    },
    {
      path: 'config',
      name: 'int-salla-config',
      meta: {
        title: 'integrations.salla.config_title_trans',
        breadcrumbs: sallaBreadcrumbs({
          label: 'integrations.salla.config_title_trans',
          route: { name: 'int-salla-config' },
        }),
      },
      component: () => import('@/views/Main/integrations/salla/SallaConfig.vue'),
    },
    {
      path: 'event-config/:eventId',
      name: 'int-salla-event-config',
      meta: {
        title: 'integrations.salla.events_title_trans',
        breadcrumbs: sallaBreadcrumbs({
          label: 'integrations.salla.events_title_trans',
          route: { name: 'int-salla-events' },
        }),
      },
      component: () => import('@/views/Main/integrations/salla/SallaEventConfig.vue'),
    },
  ],
};

// Public OAuth callback; mounted directly under main (outside /integrations) in main.router.ts
export const sallaCallbackRoute: RouteRecordRaw = {
  path: '/auth/salla/callback',
  name: 'salla-callback',
  component: () => import('@/views/Main/integrations/salla/SallaCallback.vue'),
  meta: {
    title: 'Salla - Connection',
    public: true,
  },
};
